// extracted by mini-css-extract-plugin
module.exports = {"banner":"styles_banner__uPo6j","active":"styles_active__1hVXO","banner__message":"styles_banner__message__3LPXj","banner__actions":"styles_banner__actions__3qHtN"};